import { render, staticRenderFns } from "./pt-modes.vue?vue&type=template&id=395544be&"
import script from "./pt-modes.vue?vue&type=script&lang=js&"
export * from "./pt-modes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports